var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ active: _vm.measureActive, AngleMeasurement: _vm.AngleMeasurement },on:{"click":_vm.toggleMeasure}},[_c('img',{attrs:{"src":"/static/images/Path@2x.png","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }